import axios from 'axios'
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react'
import { usePapaParse } from 'react-papaparse';
import { useCSVDownloader } from 'react-papaparse';
import FileDownloadOffIcon from '@mui/icons-material/FileDownloadOff';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import MenuIcon from '@mui/icons-material/Menu';
import CustomSpinner from '../components/CustomSpinner';
function DownloadHistory({ serverURL, user, setShowSideOverlay }) {
    const { jsonToCSV } = usePapaParse();
    const { CSVDownloader, Type } = useCSVDownloader();

    const [allHistory, setAllHistory] = useState([])
    const [historyLoading, setHistoryLoading] = useState(true)

    const getAllHistory = async () => {
        setHistoryLoading(true)
        const getData = await axios.post(serverURL + "/downloadhistory/getAll");
        if (getData.status === 200) {
            console.log(getData.data)
            setAllHistory(getData.data.filter((history) => { return history.data.requestFrom === user.email }))
            setHistoryLoading(false)
        } else {
            console.log(getData.data)
            setHistoryLoading(false)
        }
    }

    useEffect(() => {
        getAllHistory()
    }, [])

    return (
        <>
            <div className="transback h-100 overflow-auto p-3 d-flex flex-column">
                <button className='btn text-secondary rounded-pill px-3 py-1 d-flex d-lg-none d-xl-none d-xxl-none align-items-center gap-2' onClick={() => { setShowSideOverlay(true) }}>
                    <MenuIcon />
                </button>
                <div className="headerUserDetails py-1 mb-3 border-0 d-flex justify-content-between">
                    <span>Download History</span>
                    <div className='d-flex gap-2 align-items-center justify-content-center text-dark px-2' style={{ cursor: "pointer" }} title={"Name: " + user.name + "\nEmail: " + user.email}>
                        <i className='fa fa-user'></i>
                        <span>{user.name}</span>
                    </div>
                </div>
                <div className='w-100 h-100 overflow-auto'>
                    {
                        !historyLoading ?
                            <table className='table table-bordered mb-0'>
                                <thead className='table-dark sticky-top'>
                                    <tr align="center" valign="middle">
                                        <th>Action</th>
                                        <th>Request Date</th>
                                        <th>Request By</th>
                                        <th>Status</th>
                                        <th>Action Taken By</th>
                                        <th>Action Taken On</th>
                                    </tr>
                                </thead>
                                <thead>
                                    {
                                        allHistory.length > 0 ?
                                            allHistory.map((history, key) => {
                                                return (
                                                    <tr align="center" key={key} valign="middle">
                                                        <td className='text-capitalize' width="1%">
                                                            {
                                                                history.status === "approved" ?
                                                                    <CSVDownloader
                                                                        type={Type.Button}
                                                                        filename={history.data.requestName.label + " " + dayjs().format("DD MMM YYYY HH:mm:ss")}
                                                                        bom={true}
                                                                        config={{
                                                                            delimiter: ',',
                                                                        }}
                                                                        className="btn btn-sm btn-success rounded-pill w-100 rounded-pill px-3"
                                                                        data={
                                                                            jsonToCSV(
                                                                                history.data.requestedData
                                                                            )
                                                                        }
                                                                    >
                                                                        <FileDownloadIcon />
                                                                    </CSVDownloader>
                                                                    :
                                                                    <button className='btn btn-sm w-100 btn-secondary w-100 rounded-pill px-3' disabled>
                                                                        <FileDownloadOffIcon />
                                                                    </button>
                                                            }
                                                        </td>

                                                        <td>{dayjs(parseInt(history.time)).format("DD MMM YYYY, HH:mm:ss")}</td>
                                                        <td>{history.data.requestFrom}</td>
                                                        <td style={{ fontSize: "1.2rem" }}>
                                                            {
                                                                history.status === "approved" ?
                                                                    <i className='fa fa-check'></i>
                                                                    :
                                                                    history.status === "pending" ?
                                                                        <i className='fa fa-clock'></i>
                                                                        :
                                                                        history.status === "rejected" ?
                                                                            <i className='fa fa-times'></i>
                                                                            :
                                                                            <i className='fa fa-check'></i>

                                                            }
                                                        </td>
                                                        <td>{history.status !== "pending" ? history.updatedBy?.name : "..."}</td>
                                                        <td>{history.status !== "pending" ? dayjs(history.updatedAt).format("DD MMM YYYY, HH:mm:ss") : "..."}</td>
                                                    </tr>
                                                )
                                            })
                                            :
                                            <tr>
                                                <td colSpan={6}>
                                                    <div className="glassInfo text-center">No Records for now</div>
                                                </td>
                                            </tr>
                                    }
                                </thead>
                            </table>
                            :
                            <div className='w-100 h-100 d-flex flex-column justify-content-center align-items-center gap-2'>
                                <CustomSpinner size={1}/>
                                <span className='text-light fs-6'>Getting History</span>
                            </div>
                    }
                </div>
            </div>
        </>
    )
}

export default DownloadHistory